const VARIANT_SIZES = [64, 128, 256, 512];
const APPROVED_HOSTS = [
  'branch-production-bucket.s3.amazonaws.com',
  'branch-dev-bucket.s3.amazonaws.com',
  'branch-staging-bucket.s3.amazonaws.com',
];
const APPROVED_PREFIXES = [
  'images/candidates/',
  'images/users/',
  'candidateSelfUploads/',
  'faces/',
];

const encodeKey = key => key.split('/').map(encodeURIComponent).join('/');

const getVariantUrl = (src, width) => {
  if (typeof src !== 'string' || !VARIANT_SIZES.includes(width)) return null;

  try {
    const url = new URL(src);
    if (url.protocol !== 'https:' || !APPROVED_HOSTS.includes(url.hostname)) return null;

    const key = decodeURIComponent(url.pathname.replace(/^\/+/, ''));
    const prefix = APPROVED_PREFIXES.find(candidate => key.startsWith(candidate));
    if (!prefix || key.startsWith(`${prefix}variants/`)) return null;

    const relativeKey = key.slice(prefix.length);
    if (!relativeKey || relativeKey.split('/').includes('..')) return null;

    url.pathname = `/${encodeKey(`${prefix}variants/${relativeKey}/${width}.webp`)}`;
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch (error) {
    return null;
  }
};

const getVariantSrcSet = src => VARIANT_SIZES
  .map(width => {
    const url = getVariantUrl(src, width);
    return url ? `${url} ${width}w` : null;
  })
  .filter(Boolean)
  .join(', ');

export {
  getVariantSrcSet,
  getVariantUrl,
  VARIANT_SIZES,
};
